import { FC } from "react";

import { Image } from "components";
import { MenuItems } from "services/app/types";

import Copyright from "./Copyright";
import SiteMap from "./SiteMap";
import Terms from "./Terms";

interface LayoutFooterProps {
  menuItems: MenuItems;
}

const Footer: FC<LayoutFooterProps> = ({ menuItems }) => (
  <footer className="footer">
    <div className="-container">
      <div className="-icon">
        <Image name="re-mark.png" />
      </div>
      <SiteMap menuItems={menuItems} />
      <Copyright />
      <Terms />
    </div>
  </footer>
);

export default Footer;
